import { Thumbnail } from '../../../Thumbnail/Thumbnail';

import type { FC } from 'react';

import styles from './Asset.module.scss';

// TODO: open preview in player on click

type Props = {
  asset: {
    images?: { main?: string | null };
    title?: string;
  };
  className?: string;
};

const Asset: FC<Props> = ({ asset, className }) => {
  return (
    <div className={className}>
      <Thumbnail
        url={`${asset.images?.main}?t[]=161x91q80`}
        alt={asset.title}
      />
      <div className={styles.title}>{asset.title}</div>
    </div>
  );
};

export { Asset };
